import { Component } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';
import { IDropdownListCode } from '../../add-edit-exam-agency/interface/exam-agency.interface';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamCourseMaster } from '../enum/course-master.enum';
import {
  IAddEditExamCourseMasterParam,
  ICourse,
  IExamCourseMasterRequest,
} from '../../course-master-add-edit/interface/course-master.interface';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { options1 } from '../config/tiny-config';
import { CourseManagementService } from '../services/course.service';
import { forkJoin, Subject } from 'rxjs';
import { CourseManagementHttpService } from '../services/course-http.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { validateOfferNotGreater } from 'src/app/Validators/Validators';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationAddEditComponent } from 'src/app/Component/notification-management/notification-add-edit/notification-add-edit.component';
import { takeUntil } from 'rxjs/operators';
import { TinyEditorModalComponent } from 'src/app/common/tiny-editor-modal/tiny-editor-modal.component';

@Component({
  selector: 'app-course-plan-add-edit',
  templateUrl: './course-plan-add-edit.component.html',
  styleUrls: ['./course-plan-add-edit.component.css'],
})
export class CoursePlanAddEditComponent {
  counter: any = [];
  NewCoursePlanId: number
  messageRelease: string = '(This Course Plan is already Subscribed)';
  isSubs = false;
  courseList :ICourse[] = [];
  public coursePlans: any = [];
  option = ['Yes', 'No'];
  optionDesc = [
    {
      Code: 'Y',
      Description: 'Yes',
    },
    {
      Code: 'N',
      Description: 'No',
    },
  ];
  today = (() => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`; // YYYY-MM-DD
})();

  public env = environment;
  addCoursePlanForm = this.fb.group({
    Course: new FormControl(),
    Clone_Course_Plan: this.fb.control([]),
    coursePlanFeature: this.fb.array([this.createCoursePlanFeature({}, true)]),
    Course_Plan_Id: new FormControl(),
    Course_Id: new FormControl(),
    Course_Name: new FormControl(),
    Course_Plan_Name: new FormControl('', Validators.required),
    Exam_Short_Name: new FormControl(),
    Course_Plan_Type_Code: new FormControl('', Validators.required),
    Course_Current_Offer_Price: new FormControl(),
    CoursePlanCurrentOfferPriceEndDate: new FormControl(),
    Course_Plan_Type_Name: new FormControl(),
    Course_Plan_Available_Date: new FormControl('', Validators.required),
    Course_Standard_Price: new FormControl(),
    Course_Duration_Type_Code: new FormControl('', Validators.required),
    Course_Duration_Type_Name: new FormControl(),
    Course_Caption: new FormControl(),
    Released_Ind: new FormControl(),
    Trial_Number_Of_Days: new FormControl(),
    Best_Value_Ind: new FormControl(),
    Upgradable_Ind: new FormControl(),
    Number_Of_Hours_Of_Materials_Included: new FormControl(),
    Number_Of_Questions_Incuded: new FormControl(),
    Number_Of_Lesson_Notes_Included: new FormControl(),
    Number_Of_Videos_Included: new FormControl(),
    Number_Of_Flashcards_Included: new FormControl(),
    Course_Plan_Icon_Image_File_Object_Id: new FormControl(),
    Course_Plan_Logo_Image_File_Name: new FormControl(),
    Course_Plan_Logo_Image_File_Name_In_Server: new FormControl(),
    Course_Plan_Logo_Image_File_Type_Code: new FormControl(),
    Course_Plan_Logo_Image_File_Location_Name: new FormControl(),
    Course_Plan_Logo_Image_File_Source_Modified_Datetime: new FormControl(),
    Course_Plan_Logo_Image_Image_Height: new FormControl(),
    Course_Plan_Logo_Image_Image_Width: new FormControl(),
    Course_Plan_Logo_Image_Deleted_Ind: new FormControl(),
    Course_Plan_Ind: new FormControl(),
    previewFile: new FormControl(),
    file: new FormControl(),
    Course_Plan_Logo_Image_Archive_Ind: new FormControl(),
  },{
    validators: [validateOfferNotGreater() ,this.endAfterStartValidator('Course_Plan_Available_Date', 'CoursePlanCurrentOfferPriceEndDate')]
  });
  public coursePlanMode: ExamCourseMaster;
  previewTextDisplayFLag = false;

  examAgencyRequestParam: IExamCourseMasterRequest = {
    loggedInUserId: '',
    examAgencyId: '',
    courseMasterId: '',
    courseId: '',
    examAgencyName: '',
    coursePlanId: '',
    courseName: '',
  };
  tinyConfig = options1;

  public coursePlanType: Array<IDropdownListCode> = [];
  public courseDurationType: Array<IDropdownListCode> = [];
  public courseFeatureType: Array<IDropdownListCode> = [];
  public currency: Array<IDropdownListCode> = [];
  initialFormValues: any;
  courseToBeCloned: any;
  fileType: string;

  constructor(
    private readonly toaster: ToastrService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,
    private readonly courseManagementService: CourseManagementService,
    private contentService:CourseManagementHttpService,
    private modalServiceLocal: ModalService,
    private modalService: NgbModal,
  ) {
    for (let i = 0; i <= 100; i++) {
      this.counter.push(i + '');
    }

    this.addCoursePlanForm.get('Course_Name')?.disable();
    this.initialFormValues = this.addCoursePlanForm.getRawValue();
  }

  ngOnInit() {
    this.retrieveLoggedInUserId();
    this.checkExamModeEditOrAdd();
    this.fetchDropDownList();
    this.getCourses();
    // this.getCoursePlans();
    // For Date validation
  this.startCtrl?.valueChanges.subscribe(() => {
    this.endCtrl?.updateValueAndValidity({ onlySelf: true });
    console.log(this.addCoursePlanForm.get('CoursePlanCurrentOfferPriceEndDate'))
  });

  }

  async CreateNotification(): Promise<boolean> {
    try {
      // Step 1: Ask for confirmation
      const result = await this.modalServiceLocal.open(
        'Confirmation',
        'Do you want to send notification to all the users about this Course Plan?',
        'Yes',
        'No'
      );

      if (!result) {
        // this.navToCourseFallback()
        return false; // user cancelled
      }

      // Step 2: Open notification modal
      const modalRef = this.modalService.open(NotificationAddEditComponent, {
        centered: true,
        size: 'xl',
        windowClass: 'custom-modal-width-notification-course',
        backdropClass: 'custom-backdrop-notification'
      });

      // Pass data into modal
      modalRef.componentInstance.screenName = 'CoursePlan';
      modalRef.componentInstance.MaterialId =this.addCoursePlanForm.getRawValue().Course_Plan_Id || this.NewCoursePlanId

      // Step 3: Wait for modal close result
      const notificationResult = await modalRef.result
        .then((res: any) => {res

          // this.navToCourseFallback()
        })
        .catch(() =>{
          // this.navToCourseFallback()
          return false

        });


      return !!notificationResult;
    } catch (error) {
      console.error('CreateNotification dismissed or failed:', error);
      return false;
    }
  }




  get visibleCourseFeatures(): FormGroup[] {
  return (this.coursePlanFeatures?.controls || []).filter(
    (g: any) => !g.get('delI')?.value
  );
  }

    // DATE VALIDATION START


/** Getter helpers for template */
get startCtrl() {
  return this.addCoursePlanForm.get('Course_Plan_Available_Date');
}
get endCtrl() {
  return this.addCoursePlanForm.get('CoursePlanCurrentOfferPriceEndDate');
}

/** Use for the input[min] so it always gets 'YYYY-MM-DD' */
get availableDateISO(): string | null {
  const v = this.startCtrl?.value;
  if (!v) return null;
  return typeof v === 'string' ? v : this.toISODate(v);
}

private toISODate(d: any): string {
  const date = d instanceof Date ? d : new Date(d);
  // Normalize to local date (avoid TZ off-by-one)
  const tzFixed = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return tzFixed.toISOString().slice(0, 10);
}

/** Form-level validator: end >= start */
private endAfterStartValidator(startKey: string, endKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const start = group.get(startKey)?.value;
    const end = group.get(endKey)?.value;
    if (!start || !end) {
      group.get(endKey)?.setErrors(null);
      return null;
    }
    const startDate = new Date(start);
    const endDate = new Date(end);

    if (endDate < startDate) {
      const prev = group.get(endKey)?.errors || {};
      group.get(endKey)?.setErrors({ ...prev, endBeforeStart: true });
    } else {
      const errs = group.get(endKey)?.errors;
      if (errs) {
        delete errs['endBeforeStart'];
        group.get(endKey)?.setErrors(Object.keys(errs).length ? errs : null);
      }
    }
    return null;
  };
}

    // DATE VALIDATION END



  public getCourses() {
    this.courseManagementService
      .getCourses<Array<ICourse>>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.courseMasterId,
        null,
        'ADMIN',
        null
      )
      .subscribe((courses) => {
        this.courseList = courses;

        // this.addCoursePlanForm.get('Course')?.patchValue(this.examAgencyRequestParam?.courseId)
      });
  }


  onCourseChange(event?: any) {

    const preservedValues = {
      Course_Name: this.addCoursePlanForm.get('Course_Name')?.value,
      Course: this.addCoursePlanForm.get('Course')?.value,

    };

    this.addCoursePlanForm.reset({
      ...this.getInitialCoursePlanFormValues(),
      ...preservedValues
    });


    // Reset FormArray manually (reset() only resets controls, not nested arrays)
    const coursePlanFeatureArray = this.addCoursePlanForm.get('coursePlanFeature') as FormArray;
    coursePlanFeatureArray.clear();
    const feature = this.createCoursePlanFeature({}, true);
    if (feature) {
      coursePlanFeatureArray.push(feature);
    }

    if(event){
    const courseId = event.target.value;
        this.getCoursePlans(courseId);
    }

  }
  clearCourseSelection(): void {
    this.courseToBeCloned = null;
  this.addCoursePlanForm.get('Course')?.reset();
    this.onCourseChange()

  this.addCoursePlanForm.get('Clone_Course_Plan')?.reset();
  if (Array.isArray(this.coursePlans)) {
    this.coursePlans = [];
  }
}







  getCoursePlans(courseId?:string) {
    if (!this.examAgencyRequestParam.courseId) return;
    this.courseManagementService
      .getCoursePlans(
        this.examAgencyRequestParam.loggedInUserId,
        courseId ? +courseId : +this.examAgencyRequestParam.courseId,
        null,
        'ADMIN',
        null,
        null
      )
      .subscribe((elem: any) => {
        this.coursePlans = elem.coursePlan.map((coursePlan: any) => {
          const cpfName = elem.coursePlanFeature.filter(
            (cpf: any) => cpf.Course_Plan_Id === coursePlan.Course_Plan_Id
          );
          return {
            ...coursePlan,
            coursePlanFeature: cpfName,
            courseFeatureTypeNames: this.courseFeatureType.map((cpfn: any) => {
              const flag = cpfName.find((cp: any) =>
                Object.values(cp).includes(cpfn.Code)
              );
              return {
                ...cpfn,
                isActive: !!flag,
              };
            }),
          };
        });
      });
  }

  OnCoursePlanChange(event:any){
    const value  = event.target.value;
    console.log(value,this.coursePlans,"coursePlanand Features");

    const elem = this.coursePlans.find((e:any)=> e.Course_Plan_Id == value);
    const courseP = elem
    this.courseToBeCloned = courseP;
    this.patchCoursePlanForm(courseP);
    this.updateCoursePlanFeatures(elem.coursePlanFeature, true);
          this.initialFormValues = this.addCoursePlanForm.getRawValue();

  }

  private patchCoursePlanForm(courseP: any) {
    const form = this.addCoursePlanForm;
    form.patchValue({
      Course_Id: courseP.Course_Id,
      Course_Name: courseP.Course_Name,
      Course_Plan_Name: null,
      Exam_Short_Name: courseP.Exam_Short_Name,
      Course_Plan_Type_Code: null,
      Course_Plan_Type_Name: null,
      Course_Plan_Available_Date: this.parseDate(courseP.Course_Plan_Available_Date),
      Course_Current_Offer_Price: courseP?.Course_Plan_Current_Offer_Price?.toFixed(2),
      CoursePlanCurrentOfferPriceEndDate: this.parseDate(courseP?.Course_Plan_Current_Offer_Price_End_Date),
      Course_Standard_Price: courseP.Course_Plan_Standard_Price?.toFixed(2),
      Course_Duration_Type_Code: courseP.Course_Plan_Duration_Type_Code,
      Course_Duration_Type_Name: courseP.Course_Plan_Duration_Type_Name,
      Course_Caption: courseP.Course_Plan_Caption,
      Released_Ind: courseP.Released_Ind === 'Y',
      Trial_Number_Of_Days: courseP.Trial_Number_Of_Days,
      Best_Value_Ind:false, // Keeping it false because user need to check them again to trigger related validations
      Upgradable_Ind: false,
      Number_Of_Hours_Of_Materials_Included: courseP.Number_Of_Hours_Of_Materials_Included,
      Number_Of_Questions_Incuded: courseP.Number_Of_Questions_Incuded,
      Number_Of_Lesson_Notes_Included: courseP.Number_Of_Lesson_Notes_Included,
      Number_Of_Videos_Included: courseP.Number_Of_Videos_Included,
      Number_Of_Flashcards_Included: courseP.Number_Of_Flashcards_Included,
      Course_Plan_Icon_Image_File_Object_Id: courseP.Course_Plan_Icon_Image_File_Object_Id,
      Course_Plan_Logo_Image_File_Name: courseP.Course_Plan_Logo_Image_File_Name,
      Course_Plan_Logo_Image_File_Name_In_Server: courseP.Course_Plan_Logo_Image_File_Name_In_Server,
      Course_Plan_Logo_Image_File_Type_Code: courseP.Course_Plan_Logo_Image_File_Type_Code,
      Course_Plan_Logo_Image_File_Location_Name: courseP.Course_Plan_Logo_Image_File_Location_Name,
      Course_Plan_Logo_Image_File_Source_Modified_Datetime: courseP.Course_Plan_Logo_Image_File_Source_Modified_Datetime,
      Course_Plan_Logo_Image_Image_Height: courseP.Course_Plan_Logo_Image_Image_Height,
      Course_Plan_Logo_Image_Image_Width: courseP.Course_Plan_Logo_Image_Image_Width,
      Course_Plan_Logo_Image_Deleted_Ind: 'N',
      Course_Plan_Ind: courseP.Course_Plan_Ind,
      Course_Plan_Logo_Image_Archive_Ind: courseP.Course_Plan_Logo_Image_Archive_Ind,

    });

    // Toggle checkboxes
    form.get('Released_Ind')?.setValue(courseP.Released_Ind === 'Y');
    // form.get('Best_Value_Ind')?.setValue(courseP.Best_Value_Ind === 'Y');
    // form.get('Upgradable_Ind')?.setValue(courseP.Upgradable_Ind === 'Y');

    // Disable if subscribed
    this.isSubs = courseP.Subscribed_Ind === 'Y';
    form.get('Released_Ind')?.[this.isSubs ? 'disable' : 'enable']();
  }
  private updateCoursePlanFeatures(features: any[] = [], isNew = false) {
    const fa = this.addCoursePlanForm.get('coursePlanFeature') as FormArray;
    fa.clear();

    if (features.length) {

      features.forEach((f) => {
            const FeatureExists = this.courseFeatureType && this.courseFeatureType.some((e)=> e.Code ===f?.Course_Feature_Type_Code );
        if(FeatureExists){
            this.addCoursePlanFeature(f, f.New_Feature_Ind === 'Y')
        }
      });

    } else {
      this.addCoursePlanFeature({}, isNew);
    }
  }

  onPlanTypeChange(event:any){
    const courseType = this.coursePlanType.find((e)=> e.Code === event.target.value )

    if(this.courseToBeCloned){
    if(this.courseToBeCloned?.Course_Plan_Type_Code !== courseType?.Code){
      this.addCoursePlanForm.get('Course_Plan_Icon_Image_File_Object_Id')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name_In_Server')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Type_Code')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Location_Name')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Source_Modified_Datetime')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_Image_Height')?.setValue(null);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_Image_Width')?.setValue(null);
    }else if (this.courseToBeCloned?.Course_Plan_Type_Code === courseType?.Code) {
      this.addCoursePlanForm.get('Course_Plan_Icon_Image_File_Object_Id')?.setValue(this.courseToBeCloned.Course_Plan_Icon_Image_File_Object_Id);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_File_Name);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name_In_Server')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_File_Name_In_Server);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Type_Code')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_File_Type_Code);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Location_Name')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_File_Location_Name);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Source_Modified_Datetime')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_File_Source_Modified_Datetime);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_Image_Height')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_Image_Height);
      this.addCoursePlanForm.get('Course_Plan_Logo_Image_Image_Width')?.setValue(this.courseToBeCloned.Course_Plan_Logo_Image_Image_Width);
    }
    }
    this.addCoursePlanForm.get('Course_Plan_Name')?.setValue(courseType?.Description)


  }
  private getInitialCoursePlanFormValues() {
    return {
      Course: [],
      Clone_Course_Plan: [],
      coursePlanFeature: [this.createCoursePlanFeature({}, true)],
      Course_Plan_Id: null,
      Course_Id: null,
      // Course_Name: null,
      Course_Plan_Name: null,
      Exam_Short_Name: null,
      Course_Plan_Type_Code: '',
      Course_Current_Offer_Price: null,
      CoursePlanCurrentOfferPriceEndDate: null,
      Course_Plan_Type_Name: null,
      Course_Plan_Available_Date: '',
      Course_Standard_Price: null,
      Course_Duration_Type_Code: '',
      Course_Duration_Type_Name: null,
      Course_Caption: null,
      Released_Ind: null,
      Trial_Number_Of_Days: null,
      Best_Value_Ind: null,
      Upgradable_Ind: null,
      Number_Of_Hours_Of_Materials_Included: null,
      Number_Of_Questions_Incuded: null,
      Number_Of_Lesson_Notes_Included: null,
      Number_Of_Videos_Included: null,
      Number_Of_Flashcards_Included: null,
      Course_Plan_Icon_Image_File_Object_Id: null,
      Course_Plan_Logo_Image_File_Name: null,
      Course_Plan_Logo_Image_File_Name_In_Server: null,
      Course_Plan_Logo_Image_File_Type_Code: null,
      Course_Plan_Logo_Image_File_Location_Name: null,
      Course_Plan_Logo_Image_File_Source_Modified_Datetime: null,
      Course_Plan_Logo_Image_Image_Height: null,
      Course_Plan_Logo_Image_Image_Width: null,
      Course_Plan_Logo_Image_Deleted_Ind: null,
      Course_Plan_Ind: null,
      previewFile: null,
      file: null
    };
  }

private navToCourseFallback() {
  const { courseMasterId, examAgencyId, courseId } = this.examAgencyRequestParam;
  this.router.navigateByUrl(
    `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${courseMasterId || ''}&examAgencyId=${examAgencyId || ''}&type=Edit&courseId=${courseId || ''}`
  );
}

async openDescritionEditor(){
    const modalRef = this.modalService.open(
      TinyEditorModalComponent,
      { size: 'xl', backdrop: 'static', centered: true }
    );
  const current = this.addCoursePlanForm.get('Course_Caption')?.value || '';
  modalRef.componentInstance.description = current;

  try {
    const updated: string = await modalRef.result; // resolves on .close()
    this.addCoursePlanForm.patchValue({ Course_Caption: updated });
    this.addCoursePlanForm.get('Course_Caption')?.markAsDirty();
    this.addCoursePlanForm.get('Course_Caption')?.markAsTouched();
  } catch {
    // dismissed (Cancel / ESC / backdrop) — do nothing
  }
}

  get truncatedDescription(): string {
  const raw = this.addCoursePlanForm.get('Course_Caption')?.value || '';
  const tmp = document.createElement('div');
  tmp.innerHTML = raw;                     // parse HTML
  const text = tmp.textContent || tmp.innerText || '';

  const maxLength = 130;                   // set your limit
  return text.length > maxLength
    ? text.substring(0, maxLength) + '…'
    : text;

  }


  formSubmit(isDelete=false) {
    if (!this.checkChanges()) {
      return;
    }
    const deleted = String(this.addCoursePlanForm.get('Course_Plan_Logo_Image_Deleted_Ind')?.value || 'N')
      .toUpperCase() === 'Y';

    const newFile = !!this.addCoursePlanForm.get('file')?.value;
    const existingName = String(this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name_In_Server')?.value || '')
      .trim();

// Invalid when:
// - user marked it deleted but didn't upload a replacement, OR
// - user did NOT mark it deleted and there is neither an existing name nor a new upload.
const logoMissing = (deleted && !newFile) || (!deleted && !existingName && !newFile);

if (logoMissing) {
  this.toaster.error('Course Plan Logo is required', 'Error', { timeOut: 3000 });
  return;
}



    if (isDelete || this.addCoursePlanForm.valid) {
      const formdata = new FormData();

      if (this.addCoursePlanForm.getRawValue().file) {
        formdata.append(
          'file1',
          this.addCoursePlanForm.getRawValue().file,
          this.addCoursePlanForm.getRawValue().file?.name || ''
        );
      }

      formdata.append(
        'LoggedInUser',
        this.examAgencyRequestParam.loggedInUserId || ''
      );
      formdata.append(
        'CoursePlanId',
        this.examAgencyRequestParam.coursePlanId || ''
      );
      formdata.append(
        'ExamAgencyIdForFileManagement',
        this.examAgencyRequestParam.examAgencyId || ''
      );
      formdata.append('CourseId', this.examAgencyRequestParam.courseId || '');
      formdata.append(
        'CoursePlanTypeCode',
        this.addCoursePlanForm.getRawValue().Course_Plan_Type_Code || ''
      );
      formdata.append('CoursePlanSequenceNumber', '1');
      formdata.append(
        'CoursePlanName',
        this.addCoursePlanForm.getRawValue().Course_Plan_Name || ''
      );
      formdata.append('CloneInd', this.courseToBeCloned ? 'Y' : 'N');
      formdata.append(
        'CoursePlanAvailableDate',
        this.addCoursePlanForm.getRawValue().Course_Plan_Available_Date || ''
      );
      formdata.append(
        'CoursePlanLogoImageArchiveInd',
        this.addCoursePlanForm.getRawValue().Course_Plan_Logo_Image_Archive_Ind || ''
      );
      formdata.append(
        'CourseStandardPrice',
        this.addCoursePlanForm.getRawValue().Course_Standard_Price || ''
      );
      formdata.append(
        'Course_Current_Offer_Price',
        this.addCoursePlanForm.getRawValue().Course_Current_Offer_Price || ''
      );
      formdata.append(
        'CoursePlanCurrentOfferPriceEndDate',
        this.addCoursePlanForm.getRawValue().CoursePlanCurrentOfferPriceEndDate || ''
      );
      formdata.append(
        'CourseDurationTypeCode',
        this.addCoursePlanForm.getRawValue().Course_Duration_Type_Code || ''
      );
      formdata.append(
        'CourseCaption',
        this.addCoursePlanForm.getRawValue().Course_Caption || ''
      );
      formdata.append(
        'ReleasedInd',
        this.addCoursePlanForm.getRawValue().Released_Ind ? 'Y' : 'N'
      );
      formdata.append(
        'TrialNumberOfDays',
        this.addCoursePlanForm.getRawValue().Trial_Number_Of_Days || ''
      );
      formdata.append(
        'BestValueInd',
        this.addCoursePlanForm.getRawValue().Best_Value_Ind ? 'Y' : 'N'
      );
      formdata.append(
        'UpgradableInd',
        this.addCoursePlanForm.getRawValue().Upgradable_Ind ? 'Y' : 'N'
      );
      formdata.append(
        'NumberOfHoursOfMaterialsIncluded',
        this.addCoursePlanForm.getRawValue().Number_Of_Hours_Of_Materials_Included || ''
      );
      formdata.append(
        'NumberOfQuestionsIncuded',
        this.addCoursePlanForm.getRawValue().Number_Of_Questions_Incuded || ''
      );
      formdata.append(
        'NumberOfLessonNotesIncluded',
        this.addCoursePlanForm.getRawValue().Number_Of_Lesson_Notes_Included || ''
      );
      formdata.append(
        'NumberOfVideosIncluded',
        this.addCoursePlanForm.getRawValue().Number_Of_Videos_Included || ''
      );
      formdata.append(
        'NumberOfFlashcardsIncluded',
        this.addCoursePlanForm.getRawValue().Number_Of_Flashcards_Included || ''
      );
      formdata.append(
        'CoursePlanLogoImageFileObjectId',
        this.addCoursePlanForm.getRawValue().file ?'null': (this.addCoursePlanForm.getRawValue().Course_Plan_Icon_Image_File_Object_Id || 'null')
      );
      formdata.append(
        'CoursePlanLogoImageFileName',
        this.addCoursePlanForm.getRawValue().file ?'null': (this.addCoursePlanForm.getRawValue().Course_Plan_Logo_Image_File_Name || ' null')
      );
      formdata.append(
        'CoursePlanLogoImageFileNameInServer',
        this.addCoursePlanForm.getRawValue().file ?'null':(this.addCoursePlanForm.getRawValue()
          .Course_Plan_Logo_Image_File_Name_In_Server ||'null')
      );
      formdata.append(
        'CoursePlanLogoImageFileSourceModifiedDateTime',
        this.addCoursePlanForm.getRawValue().file ?'null':(this.addCoursePlanForm.getRawValue()
          .Course_Plan_Logo_Image_File_Source_Modified_Datetime || 'null')
      );
      formdata.append('CoursePlanLogoImageFileTypeCode',this.addCoursePlanForm.getRawValue().file ?'null': (this.fileType || 'null'));
      formdata.append(
        'CoursePlanLogoImageFileLocationName',
        this.addCoursePlanForm.getRawValue().file ?'null':(this.addCoursePlanForm.getRawValue()
          .Course_Plan_Logo_Image_File_Location_Name || 'null')
      );
      formdata.append(
        'CoursePlanLogoImageImageHeight',
       this.addCoursePlanForm.getRawValue().file ?'null': (this.addCoursePlanForm.getRawValue().Course_Plan_Logo_Image_Image_Height || 'null')
      );
      formdata.append(
        'CoursePlanLogoImageImageWidth',
        this.addCoursePlanForm.getRawValue().file ?'null': (this.addCoursePlanForm.getRawValue().Course_Plan_Logo_Image_Image_Width || 'null')
      );
      formdata.append(
        'CoursePlanLogoImageDeletedInd',
        this.addCoursePlanForm.getRawValue().file ?'null': (this.addCoursePlanForm.getRawValue().Course_Plan_Logo_Image_Deleted_Ind || 'null'),
      );

      this.addCoursePlanForm.getRawValue().coursePlanFeature.forEach(
        (elem: any, index: number) => {
          formdata.append(
            `course_feature[${index}][AvailableDate]`,
            elem.availableDate || ''
          );

          formdata.append(
            `course_feature[${index}][CourseFeatureTypeCode]`,
            elem.featureName || ''
          );

          formdata.append(
            `course_feature[${index}][CurrencyCode]`,
            elem.currency || ''
          );

          formdata.append(
            `course_feature[${index}][CustomToolTipDesciption]`,
            elem.toolTip
          );

          formdata.append(
            `course_feature[${index}][FeatureDescription]`,
            elem.description || ''
          );

          formdata.append(
            `course_feature[${index}][FeatureMoneyValue]`,
            elem.moneyValue || ''
          );

          formdata.append(
            `course_feature[${index}][FeatureValue]`,
            elem.value || ''
          );

          formdata.append(
            `course_feature[${index}][NewFeatureInd]`,
            (elem.newR === 'Y' ? true : false) + ''
          );

          formdata.append(
            `course_feature[${index}][DeletedInd]`,
            elem.delI + ''
          );
        }
      );

      formdata.append(
        'CourseFeatureLen',
        this.addCoursePlanForm.getRawValue()?.coursePlanFeature?.length || 0
      );

      this.courseManagementService
        .createOrUpdateCoursePlan(formdata)
        .subscribe((e: any) => {
          if (
            typeof e?.ErrorMsg === 'string' &&
            e.ErrorMsg.includes('XAK2COURSE_PLAN')
          ) {
            this.toaster.error('Plan Type Already Exist', '', {
              timeOut: 1500,
            });
            console.log(e.ErrorMsg.includes('XAK2COURSE_PLAN'));
          } else {
            this.NewCoursePlanId =e.NewCoursePlanId;
            if(!isDelete){
                this.router.navigate(
    ['Exam/ExamAgencies/CourseMaster/Course/CoursePlan/ViewEdit'],
    {
      queryParams: {
        type: 'Edit',
        examAgencyId: this.examAgencyRequestParam.examAgencyId || '',
        examAgencyName: this.examAgencyRequestParam.examAgencyName || '',
        courseId: this.examAgencyRequestParam.courseId || '',
        coursePlanId: this.examAgencyRequestParam.coursePlanId ? this.examAgencyRequestParam.coursePlanId:e.NewCoursePlanId || '',
        courseMasterId: this.examAgencyRequestParam.courseMasterId || '',
        courseName: this.examAgencyRequestParam.courseName || ''
      },
      state: { returnUrl: this.router.url } // <<— key line
      // do NOT use replaceUrl:true here
    }
  );
            // this.navToCourseFallback()
            this.CreateNotification()
            this.toaster.success('Saved Successfully', 'Success',{timeOut: 500});}
            this.courseToBeCloned = null; //Once saved reset the cloned course plan
            this.addCoursePlanForm.get('file')?.setValue(null);
            this.addCoursePlanForm.get('previewFile')?.setValue(null);
            this.fetchDropDownList();
          }

          this.addCoursePlanForm.markAsUntouched();
        });
    } else {
      this.addCoursePlanForm.markAllAsTouched();
    }

  }
  onBestValueChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const data = {
      LoggedInUser: this.examAgencyRequestParam.loggedInUserId ?? '',
      CourseID: this.examAgencyRequestParam.courseId ?? 0,
    };
    this.contentService.checkGetCoursePlanBestValueCheck(data).subscribe(
      (res: any) => {
        if (res.result && res.result.length > 0 && target.checked) {
          alert(
            `${res.result[0]} is already marked as Best Value.\n` +
              `If you would like to mark this plan as Best Value, please unselect ` +
              `“${res.result[0]}” first and update this plan.`
          );
          target.checked = false;
          this.addCoursePlanForm.get('Best_Value_Ind')?.setValue(false);
        }
      },
      (error: any) => {}
    );

  }

  onFeatureChange(index: number): void {
    const ctrl = this.coursePlanFeatures.at(index);
    const selectedRaw = ctrl.get('featureName')?.value;

    // ignore empty/placeholder
    if (selectedRaw === null || selectedRaw === undefined || selectedRaw === '') return;

    const selectedCode = String(selectedRaw).trim().toLowerCase();

    const duplicates = this.coursePlanFeatures.controls.filter((group: any, i: number) => {
      if (i === index) return false;
      if (group.get('delI')?.value) return false; // only this extra check you asked about
      const code = group.get('featureName')?.value;
      if (code === null || code === undefined || code === '') return false;
      return String(code).trim().toLowerCase() === selectedCode;
    });

    if (duplicates.length > 0) {
      this.toaster.error('This feature is already selected. Please choose another.', '', {
        timeOut: ConstantVars.ToastErrorTimeout,
      });
      ctrl.get('featureName')?.reset();
    }
  }


  private fetchDropDownList(isClone?: boolean) {
    forkJoin([
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'COURSE_PLAN_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'COURSE_DURATION_TYPE'
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
       `AVAILABLE_COURSE_FEATURE@${this.examAgencyRequestParam.courseId}@COURSE_PLAN`
      ),
      this.courseManagementService.getDropdownList<IDropdownListCode>(
        'CURRENCY'
      ),
    ]).subscribe((elem) => {
      const [coursePlanType, courseDurationType, courseFeatureType, currency] =
        elem as unknown as Array<Array<IDropdownListCode>>;

      this.coursePlanType = coursePlanType;
      this.courseDurationType = courseDurationType;
      this.courseFeatureType = courseFeatureType;
      this.currency = currency;

      if (!this.examAgencyRequestParam.coursePlanId) {
        this.addCoursePlanForm
          .get('Course_Name')
          ?.setValue(this.examAgencyRequestParam.courseName);
        return;
      }

        this.courseManagementService.getCoursePlans(
          this.examAgencyRequestParam?.loggedInUserId ?? '',
          +(this.examAgencyRequestParam?.courseId ?? 0),
          +(this.examAgencyRequestParam?.coursePlanId ?? 0),
          'ADMIN',
          null,
          null
        )
        .subscribe((elem: any) => {
          const courseP = (elem.coursePlan || [])[0] || {};
          this.addCoursePlanForm.patchValue({
            Course_Plan_Id: courseP.Course_Plan_Id,
            Course_Id: courseP.Course_Id,
            Course_Name: courseP.Course_Name,
            Course_Plan_Name: courseP.Course_Plan_Name,
            Exam_Short_Name: courseP.Exam_Short_Name,
            Course_Plan_Type_Code: courseP.Course_Plan_Type_Code,
            Course_Plan_Type_Name: courseP.Course_Plan_Type_Name,
            Course_Plan_Available_Date: this.parseDate(
              courseP.Course_Plan_Available_Date
            ),
            Course_Current_Offer_Price: courseP?.Course_Plan_Current_Offer_Price
              ? courseP?.Course_Plan_Current_Offer_Price.toFixed(2)
              : courseP?.Course_Plan_Current_Offer_Price,
            CoursePlanCurrentOfferPriceEndDate: this.parseDate(
              courseP?.Course_Plan_Current_Offer_Price_End_Date
            ),
            Course_Standard_Price:
              courseP.Course_Plan_Standard_Price.toFixed(2),
            Course_Duration_Type_Code: courseP.Course_Plan_Duration_Type_Code,
            Course_Duration_Type_Name: courseP.Course_Plan_Duration_Type_Name,
            Course_Caption: courseP.Course_Plan_Caption,
            Released_Ind: courseP.Released_Ind === 'Y' ? true : false,
            Trial_Number_Of_Days: courseP.Trial_Number_Of_Days,
            Best_Value_Ind: courseP.Best_Value_Ind === 'Y' ? true : false,
            Upgradable_Ind: courseP.Upgradable_Ind === 'Y' ? true : false,
            Number_Of_Hours_Of_Materials_Included:
              courseP.Number_Of_Hours_Of_Materials_Included,

            Number_Of_Questions_Incuded: courseP.Number_Of_Questions_Incuded,
            Number_Of_Lesson_Notes_Included:
              courseP.Number_Of_Lesson_Notes_Included,

            Number_Of_Videos_Included: courseP.Number_Of_Videos_Included,
            Number_Of_Flashcards_Included: courseP.Number_Of_Flashcards_Included,

            Course_Plan_Icon_Image_File_Object_Id:
              courseP.Course_Plan_Icon_Image_File_Object_Id,

            Course_Plan_Logo_Image_File_Name:
              courseP.Course_Plan_Logo_Image_File_Name,

            Course_Plan_Logo_Image_File_Name_In_Server:
              courseP.Course_Plan_Logo_Image_File_Name_In_Server,

            Course_Plan_Logo_Image_File_Type_Code:
              courseP.Course_Plan_Logo_Image_File_Type_Code,

            Course_Plan_Logo_Image_File_Location_Name:
              courseP.Course_Plan_Logo_Image_File_Location_Name,

            Course_Plan_Logo_Image_File_Source_Modified_Datetime:
              courseP.Course_Plan_Logo_Image_File_Source_Modified_Datetime,

            Course_Plan_Logo_Image_Image_Height:
              courseP.Course_Plan_Logo_Image_Image_Height,

            Course_Plan_Logo_Image_Image_Width:
              courseP.Course_Plan_Logo_Image_Image_Width,

            Course_Plan_Logo_Image_Deleted_Ind:'N',

            Course_Plan_Ind: courseP.Course_Plan_Ind,
            Course_Plan_Logo_Image_Archive_Ind: courseP.Course_Plan_Logo_Image_Archive_Ind ,
          });

          this.addCoursePlanForm
            .get('Released_Ind')
            ?.setValue(courseP.Released_Ind === 'Y' ? true : false);
          this.addCoursePlanForm
            .get('Best_Value_Ind')
            ?.setValue(courseP.Best_Value_Ind === 'Y' ? true : false);
          this.addCoursePlanForm
            .get('Upgradable_Ind')
            ?.setValue(courseP.Upgradable_Ind === 'Y' ? true : false);

          if (courseP.Subscribed_Ind === 'Y') {
            this.addCoursePlanForm.get('Released_Ind')?.disable();
            this.isSubs = true;
          } else {
            this.addCoursePlanForm.get('Released_Ind')?.enable();
            this.isSubs = false;
          }
          if (elem.coursePlanFeature.length) {
            (
              this.addCoursePlanForm.get('coursePlanFeature') as FormArray
            ).clear();
            elem.coursePlanFeature.forEach((element: any) => {
            const FeatureExists = this.courseFeatureType && this.courseFeatureType.some((e)=> e.Code ===element?.Course_Feature_Type_Code );
            if(FeatureExists){
              this.addCoursePlanFeature(element, element.New_Feature_Ind === "Y" ? true :false);
            }
            });
          }else{
            (
              this.addCoursePlanForm.get('coursePlanFeature') as FormArray
            ).clear();
            this.addCoursePlanFeature({}, false)
          }
          this.initialFormValues = this.addCoursePlanForm.getRawValue();
        });
    });
  }

  parseDate(dateStr: string) {
    if (!dateStr) return null;
    const date = new Date(dateStr);

    if (Number.isNaN(date.getTime())) return null;

    const m =
      date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    const d = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

    const _d = `${date.getFullYear()}-${m}-${d}`;

    return _d;
  }
  formatToTwoDecimals(event: FocusEvent, fieldName: string): void {
    const inputElement = event.target as HTMLInputElement;
    const value = parseFloat(inputElement.value);

    // Check if the value is a valid number
    if (!isNaN(value)) {
      const formattedValue = value.toFixed(2);
      inputElement.value = formattedValue;

      // Update the form control with the formatted value
      this.addCoursePlanForm.get(fieldName)?.setValue(formattedValue);
    }
  }

  restrictInput(event: KeyboardEvent, decimalPlaces: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Allow backspace, numbers, decimal point
    if (event.key === 'Backspace' || /[0-9\.]/.test(event.key)) {
      return;
    }

    // Limit decimal places
    const decimalIndex = value.indexOf('.');
    if (decimalIndex !== -1) {
      const decimalPart = value.substring(decimalIndex + 1);
      if (decimalPart.length > decimalPlaces) {
        event.preventDefault();
      }
    } else {
      // Prevent non-numeric input before the decimal point
      event.preventDefault();
    }
  }

// In your component:
// constructor(private toastr: ToastrService) {}

imageHandle(event: Event, controlName: string, previewControlName?: string) {
  const input = event.target as HTMLInputElement | null;
  const file = input?.files?.[0];
  if (!input || !file) return;

  // If a preview control is provided -> expect an image; otherwise -> expect a PDF
  const expectImage = !!previewControlName;
  const expectPdf = !previewControlName;

  const lowerName = (file.name || '').toLowerCase();
  const ext = lowerName.slice(lowerName.lastIndexOf('.'));
  const isJpeg = file.type === 'image/jpeg' || ext === '.jpg' || ext === '.jpeg' || file.type === 'image/png' || ext === '.png';
  const isPdf  = file.type === 'application/pdf' || ext === '.pdf';

  // Validate type strictly
  if (expectImage && !isJpeg) {
    this.toaster.error('Only JPG, JPEG and PNG images are allowed.');
    this.addCoursePlanForm.get(controlName)?.reset();
    if (previewControlName) this.addCoursePlanForm.get(previewControlName)?.reset();
    input.value = '';
    return;
  }
  if (expectPdf && !isPdf) {
    this.toaster.error('Only PDF files are allowed.');
    this.addCoursePlanForm.get(controlName)?.reset();
    input.value = '';
    return;
  }

  this.fileType = file.type.split('/')[1];
  // Set the file control
  this.addCoursePlanForm.get(controlName)?.setValue(file);

  // If we expect image, create a preview
  if (expectImage) {
    const reader = new FileReader();
    reader.onload = () => {
      this.addCoursePlanForm.get(previewControlName!)?.setValue(String(reader.result || ''));
    };
    reader.readAsDataURL(file);
  }

  // Allow picking the same file again
  input.value = '';
}


  preventEnteringString(event: KeyboardEvent, maxLen: number) {
    if (Number.isNaN(+event.key)) {
      return false;
    }

    if (((event.target as any)?.value || '').length > maxLen - 1) {
      return false;
    }

    return true;
  }

  deleteImage(controlName: string) {
    this.addCoursePlanForm.get(controlName)?.setValue('Y');
    // this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Location_Name')?.setValue(null);
    // this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name')?.setValue(null);
    // this.addCoursePlanForm.get('Course_Plan_Logo_Image_File_Name_In_Server')?.setValue(null);
    // this.addCoursePlanForm.get('Course_Plan_Icon_Image_File_Object_Id')?.setValue(null);


    // this.formSubmit(true);
  }

  clearUploadImage(type: string, previewFile: string) {
    this.addCoursePlanForm.get(type)?.setValue(null);

    if (!previewFile) return;
    this.addCoursePlanForm.get(previewFile)?.setValue(null);
  }

  async clear() {
    const currentValues = this.addCoursePlanForm.getRawValue();
    const isPristine =
      JSON.stringify(currentValues) === JSON.stringify(this.initialFormValues);
    if (!isPristine) {
      this.addCoursePlanForm.markAsPristine();
            try {
        const result = await this.modalServiceLocal.open(
          'Confirmation',
          `You have unsaved changes. Do you want to save before leaving?`
        );
        if (result) {
               this.formSubmit();
        } else {
                  this.router.navigateByUrl(
          `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${this.examAgencyRequestParam.courseId}`
        );
          }
      } catch (error) {
      }
    } else {
      // this.addEditExamCourseMaster.reset();
      this.router.navigateByUrl(
        `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${this.examAgencyRequestParam.courseId}`
      );
    }

    // if (this.addCoursePlanForm.dirty) {
    //   const flag = window.confirm('Do you want to save the changes');

    //   if (flag) {
    //     this.formSubmit();
    //   } else {
    //     this.router.navigateByUrl(
    //       `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${this.examAgencyRequestParam.courseId}`
    //     );
    //   }
    // } else {
    //   // this.addEditExamCourseMaster.reset();
    //   this.router.navigateByUrl(
    //     `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${this.examAgencyRequestParam.courseId}`
    //   );
    // }
  }


  private destroy$ = new Subject<void>();
  private checkExamModeEditOrAdd() {
    this.route.queryParamMap
    .pipe(takeUntil(this.destroy$))
    .subscribe(pm => {
      this.coursePlanMode = (pm.get('type') as ExamCourseMaster) || ('' as ExamCourseMaster);

      this.examAgencyRequestParam.examAgencyId  = pm.get('examAgencyId')||''
      this.examAgencyRequestParam.courseMasterId = pm.get('courseMasterId')||''
      this.examAgencyRequestParam.examAgencyName = pm.get('examAgencyName') || '';
      this.examAgencyRequestParam.courseId       = pm.get('courseId')||''
      this.examAgencyRequestParam.coursePlanId   = pm.get('coursePlanId')||'';
      this.examAgencyRequestParam.courseName     = pm.get('courseName') || '';
    });
  }
  ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}

  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error');

    this.examAgencyRequestParam.loggedInUserId = loggedInUserId;
    return null;
  }

  displayDialogOff() {
    this.previewTextDisplayFLag = false;
  }
  showPreviewPop() {
    this.previewTextDisplayFLag = true;
  }

  createCoursePlanFeature(obj: any, newR: boolean) {

    return this.fb.group({
      featureName: new FormControl(
       this.courseFeatureType && this.courseFeatureType.some((e)=> e.Code ===obj?.Course_Feature_Type_Code )? obj?.Course_Feature_Type_Code:'',
        Validators.required
      ),
      value: new FormControl(this.courseFeatureType && this.courseFeatureType.some((e)=> e.Code ===obj?.Course_Feature_Type_Code )? obj?.Feature_Value :'', Validators.required),
      availableDate: new FormControl(
        this.parseDate(obj?.Available_Date || new Date()),
        Validators.required
      ),
      description: new FormControl(
        obj?.Feature_Description,
        Validators.required
      ),
      currency: new FormControl(obj?.Currency_Code, Validators.required),
      moneyValue: new FormControl(
        obj?.Feature_Money_Value,
        Validators.required
      ),
      toolTip: new FormControl(
        obj?.Custom_Tool_Tip_Desciption,
        Validators.required
      ),
      newR: new FormControl(newR ? 'Y': 'N', Validators.required),
      delI: new FormControl(false, Validators.required),
    });
  // }
  }

  removeCoursePlan(index: number) {
  const group = this.coursePlanFeatures.at(index) as FormGroup;
  const controlValue = group.value?.featureName;

    if (group.value?.newR === 'Y') {
      this.coursePlanFeatures.removeAt(index);
      return;
    }

    this.coursePlanFeatures.at(index).get('delI').setValue(true);
    Object.keys(group.controls).forEach(key => {
    group.get(key)?.clearValidators();
    group.get(key)?.updateValueAndValidity({ emitEvent: false });
  });

    // this.formSubmit(true);
  }
  isLastVisibleFeature(index: number): boolean {
  // Get only the visible (non-deleted) features
  const visibleFeatures = this.coursePlanFeatures.controls.filter(
    (ctrl: FormGroup) => !ctrl.get('delI')?.value
  );

  // Check if the control at this index is the last visible one
  return (
    visibleFeatures.length > 0 &&
    this.coursePlanFeatures.controls[index] === visibleFeatures[visibleFeatures.length - 1]
  );
}


  addCoursePlanFeature(courseFeature: any, newR: boolean = false) {
    const feature = this.createCoursePlanFeature(courseFeature || {}, newR)
if (feature) {
    (this.addCoursePlanForm.get('coursePlanFeature') as FormArray)?.push(
        feature
    );
  }
  }

  get coursePlanFeatures() {
    return this.addCoursePlanForm.get('coursePlanFeature') as any;
  }

  getCounterValues(index: number) {
    const currentVal = this.addCoursePlanForm.get('coursePlanFeature');
    return [];
  }

  preventEnteringDecimalString(event: KeyboardEvent, maxLen: number) {
    try {
      if (
        Number.isFinite(+(event as any).target.value) &&
        event?.key?.length <= maxLen
      ) {
        return true;
      }

      const newVal = (event as any).target?.value?.split('');

      newVal.pop();

      (event as any).target.value = newVal.join('');

      return false;
    } catch (err) {
      const newVal = (event as any).target?.value?.split('');

      newVal.pop();

      (event as any).target.value = newVal.join('');
      return false;
    }
  }

  getNewFeatVal() {
    return this.option.map((accu) => {
      return {
        Code: accu === 'Yes' ? 'Y' : 'N',
        Description: accu,
      };
    });
  }

checkChanges(): boolean {
  const active = this.coursePlanFeatures.value.filter((v: any) => !v?.delI);
  const seen = new Set<string>();

  for (const item of active) {
    const raw = item?.featureName;
    if (!raw) continue;
    const name = String(raw).trim().toLowerCase();
    if (seen.has(name)) {
      this.toaster.warning('Feature Name used Multiple Times');
      return false;
    }
    seen.add(name);
  }
  return true;
}

}
